import React from "react";
import { X } from "lucide-react";

const WorkInProgress = ({ isOpen, onClose, onConfirm }) => {
  if (!isOpen) return null;

  return (
    <>
      <div
        className="drawer-overlay"
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={onClose}
      />
      <div
        className="entity-drawer modal-popup-cls"
        style={{
          maxWidth: 650,
          margin: "0 auto",
          background: "white",
          borderRadius: 12,
          zIndex: 1050,
          padding: 24,
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.2)",
          height: "auto",
          right: "auto",
        }}
      >
        {/* Header */}
        <div className="drawer-header d-flex justify-content-end align-items-center pt-0 pe-0">
          <button className="close-btn" onClick={onClose}>
            <X size={20} />
          </button>
        </div>

        {/* Title */}
        <h3
          style={{
            textAlign: "left",
            color: "#212529",
            fontSize: "20px",
            fontWeight: "600",
            lineHeight: "24px",
            fontFamily: "Montserrat",
            marginBottom: "5px",
          }}
        >
          New Feature in Progress
        </h3>

        {/* Description */}
        <p
          style={{
            marginBottom: "0",
            textAlign: "left",
            color: "#6C757D",
            fontSize: "14px",
            fontWeight: "400",
            lineHeight: "20px",
            fontFamily: "Montserrat",
          }}
        >
          Work in Progress
        </p>

        {/* Footer */}
        <div className="drawer-footer" style={{ paddingTop: "10px" }}>
          <button className="btn-save" onClick={onConfirm}>
            OK
          </button>
        </div>
      </div>
    </>
  );
};

export default WorkInProgress;
